import Assignment from './Assignment'

export default Assignment
